import decodeJWT, { JwtPayload } from 'jwt-decode';

import { AuthResult } from './authenticate';

export interface Authentication {
    error?: string;
    accessToken?: string;
    claims?: AuthResult;
}

export interface AuthenticationUtils extends Authentication {
    authenticate: () => Promise<void>;
}

export function getCookie(key: string): string | undefined {
    const cookieMatchArray = RegExp(`(^|;)\\s*${key}\\s*=\\s*([^;]+)`).exec(document.cookie);
    return cookieMatchArray ? cookieMatchArray.pop() : undefined;
}

export function isTokenExpired(token: string): boolean {
    try {
        const { exp } = decodeJWT<JwtPayload>(token);
        return Date.now() / 1000 >= (exp || 0);
    } catch {
        return true;
    }
}
